<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <img style="display: none;" id='reportLogo' crossorigin="Anonymous" src='https://bxi-upload-bucket.s3.ap-southeast-1.amazonaws.com/iripple-images/reports/iripple/1646293427892_report_logo.png' alt='Report Logo'>
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Status" >
                                        <a-select mode="single" v-model="inputStatus" showSearch placeholder="All Status" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                            <a-select-option v-for="option in statusOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" v-on:click='clearJsonData'> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import { getReportDescription } from '../../utilities';
    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputStatus: "",
                statusOptions: [
                    {key: "", value: "All"},
                    {key: "S", value: "Saved"},
                    {key: "C", value: "Confirmed"},
                    {key: "P", value: "Posted"},
                    {key: "V", value: "Voided"}
                ],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                reportDetails: [],
                JsonData: [],
                reportDescription: ''
            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            this.reportDescription = await getReportDescription(this.currentProfile)
            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            generateReport: async function () {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                if(this.inputSite.length == 0){
                    await this.generateReportBg();
                    return
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'sto_discrepancy_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&status=' + this.inputStatus, null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    var MAIN_HEADER = [ {content: "STO#", styles: {halign: 'center'}}, {content:"To Site", styles: {halign: 'center'}}, 
                                        {content:"Date", styles: {halign: 'center'}}, {content:"Cancel Date", styles: {halign: 'center'}}, 
                                        {content:"Status", styles: {halign: 'center'}}, {content:"STO Amount", styles: {halign: 'center'}}, 
                                        {content:"STI#", styles: {halign: 'center'}}]
                    var FIRST_HEADER = [ {content: "PCode",rowSpan: 2, styles: {lineWidth: 0.10, cellPadding: 2, halign: 'center',valign:'center'}}, {content: "Barcode",rowSpan: 2, styles: {lineWidth: 0.10, cellPadding: 2, halign: 'center',valign:'center'}},
                                          {content: "Description", rowSpan: 2, styles: {lineWidth: 0.10, cellPadding: 2, halign: 'center',valign:'center'}}, {content: "Out", colSpan:3, styles: {lineWidth: 0.10, cellPadding: 2, halign: 'center'}},
                                          {content: "In", colSpan:2, styles: {lineWidth: 0.10, cellPadding: 2, halign: 'center'}}, {content: "Balance", colSpan:2, styles: {lineWidth: 0.10, cellPadding: 2, halign: 'center'}},
                                          {content: "Balance Amount",rowSpan: 2, styles: {lineWidth: 0.10, cellPadding: 2, halign: 'center',valign:'center'}},
                    ]
                    var SECOND_HEADER = [ {content: "Content/Case", styles: {lineWidth: 0.10, cellPadding: 2, halign: 'center'}},
                                          {content: "Piece", styles: {lineWidth: 0.10, cellPadding: 2, halign: 'center'}},{content: "Case", styles: {lineWidth: 0.10, cellPadding: 2, halign: 'center'}},
                                          {content: "Piece", styles: {lineWidth: 0.10, cellPadding: 2, halign: 'center'}},{content: "Case", styles: {lineWidth: 0.10, cellPadding: 2, halign: 'center'}},
                                          {content: "Piece", styles: {lineWidth: 0.10, cellPadding: 2, halign: 'center'}},{content: "Case", styles: {lineWidth: 0.10, cellPadding: 2, halign: 'center'}},
                    ]
                    var TOP_HEADER = [FIRST_HEADER,SECOND_HEADER]

                    var ordered_per_piece_gtotal = 0,ordered_per_case_gtotal = 0,served_per_piece_gtotal = 0,served_per_case_gtotal = 0,balance_per_piece_gtotal = 0,balance_per_case_gtotal = 0,amount_balance_gtotal = 0;
                    for(var x=0; x < siteSpecific.length; x++){
                        this.reportDetails = siteSpecific[x].report_details
                        if (this.reportDetails.length > 0){
                            const ids = this.reportDetails.map(o => o.id)
                            const filtered = this.reportDetails.filter(({id}, index) => !ids.includes(id, index + 1))
                            doc.setFontSize(14);
                            doc.setFontType("bold");
                            doc.text(15,20,"Stock Transfer Out Discrepancy Report")
                            doc.setFontType("normal");
                            doc.setFontSize(10);
                            doc.text(15,25,"For the Period of " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A') + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))
                            if(x > 0){
                                //add new page
                                doc.addPage();
                            }
                            var ordered_per_piece_total = 0,ordered_per_case_total = 0,served_per_piece_total = 0,served_per_case_total = 0,balance_per_piece_total = 0,balance_per_case_total = 0,amount_balance_total = 0;
                            for(let i=0; i < filtered.length; i++){
                                let reportData = [],reportDatasecond = []
                                doc.text(15,30, filtered[i].site_name);
                                let reportdocumentDetails = filtered[i]
                                let obj = this.reportDetails.filter(o => o.id == reportdocumentDetails.id);
                                let detail = [
                                    {content: reportdocumentDetails.document_no,styles:{halign:"left"}},
                                    {content: reportdocumentDetails.to_site,styles:{halign:"left"}},
                                    {content: moment(reportdocumentDetails.document_date).format("L")},
                                    {content: moment(reportdocumentDetails.cancellation_date).format("L")},
                                    {content: reportdocumentDetails.doc_status},
                                    {content: this.convertToCurrency(Number(reportdocumentDetails.amount_net))},
                                    {content: reportdocumentDetails.sti_doc_no}
                                ];
                                reportData.push(Object.assign({}, detail))
                                doc.autoTable({
                                    head: [ MAIN_HEADER ],
                                    body: reportData,
                                    theme: 'plain',
                                    tableWidth: 'auto',
                                    headStyles: {
                                        lineWidth: 0.10,
                                        cellPadding: 2
                                    },
                                    styles: {
                                        cellPadding: 1.0, 
                                        fontSize: 10,
                                        halign: 'right',
                                        lineWidth: 0.05,
                                    },
                                    
                                    margin: { top: 40 },
                                })
                                var ordered_per_piece_subtotal = 0, ordered_per_case_subtotal = 0, served_per_piece_subtotal = 0, served_per_case_subtotal = 0, balance_per_piece_subtotal = 0, balance_per_case_subtotal = 0, amount_balance_subtotal = 0;
                                for(var o= 0; o < obj.length; o++){
                                    var reportdocumentLineDetails = obj[o];
                                    ordered_per_piece_subtotal += Number(reportdocumentLineDetails.ordered_per_piece)
                                    ordered_per_case_subtotal += Number(reportdocumentLineDetails.ordered_per_case)
                                    served_per_piece_subtotal += Number(reportdocumentLineDetails.served_per_piece)
                                    served_per_case_subtotal += Number(reportdocumentLineDetails.served_per_case)
                                    balance_per_piece_subtotal += Number(reportdocumentLineDetails.balance_per_piece)
                                    balance_per_case_subtotal += Number(reportdocumentLineDetails.balance_per_case)
                                    amount_balance_subtotal += Number(reportdocumentLineDetails.amount_balance)
                                    var lineDetails = [
                                        {content: reportdocumentLineDetails.product_id},
                                        {content: reportdocumentLineDetails.barcode},
                                        {content: reportdocumentLineDetails.description},
                                        {content: Number(reportdocumentLineDetails.content)},
                                        {content: Number(reportdocumentLineDetails.ordered_per_piece)},
                                        {content: Number(reportdocumentLineDetails.ordered_per_case)},
                                        {content: Number(reportdocumentLineDetails.served_per_piece)},
                                        {content: Number(reportdocumentLineDetails.served_per_case)},
                                        {content: Number(reportdocumentLineDetails.balance_per_piece)},
                                        {content: Number(reportdocumentLineDetails.balance_per_case)},
                                        {content: this.convertToCurrency(Number(reportdocumentLineDetails.amount_balance))}
                                    ]
                                    
                                    reportDatasecond.push(Object.assign({}, lineDetails))
                                }
                                var remarksAndSubtotal = [
                                    {content: "Remarks: ",styles:{fontStyle:"bold",halign:"left"}},
                                    {content:reportdocumentDetails.remark,colSpan:2,styles:{halign:"left"}},
                                    {},
                                    {content: "Subtotal:",styles:{fontStyle:"bold",halign:"center"}},
                                    {content: Number(ordered_per_piece_subtotal),styles:{fontStyle:"bold"}},
                                    {content: Number(ordered_per_case_subtotal),styles:{fontStyle:"bold"}},
                                    {content: Number(served_per_piece_subtotal),styles:{fontStyle:"bold"}},
                                    {content: Number(served_per_case_subtotal),styles:{fontStyle:"bold"}},
                                    {content: Number(balance_per_piece_subtotal),styles:{fontStyle:"bold"}},
                                    {content: Number(balance_per_case_subtotal),styles:{fontStyle:"bold"}},
                                    {content: this.convertToCurrency(Number(amount_balance_subtotal)),styles:{fontStyle:"bold"}},
                                ]
                                ordered_per_piece_total += ordered_per_piece_subtotal
                                ordered_per_case_total += ordered_per_case_subtotal
                                served_per_piece_total += served_per_piece_subtotal
                                served_per_case_total += served_per_case_subtotal
                                balance_per_piece_total += balance_per_piece_subtotal
                                balance_per_case_total += balance_per_case_subtotal
                                amount_balance_total += amount_balance_subtotal
                                ordered_per_piece_gtotal += ordered_per_piece_subtotal
                                ordered_per_case_gtotal += ordered_per_case_subtotal
                                served_per_piece_gtotal += served_per_piece_subtotal
                                served_per_case_gtotal += served_per_case_subtotal
                                balance_per_piece_gtotal += balance_per_piece_subtotal
                                balance_per_case_gtotal += balance_per_case_subtotal
                                amount_balance_gtotal += amount_balance_subtotal
                                reportDatasecond.push(Object.assign({}, remarksAndSubtotal))
                                reportDatasecond.push(Object.assign({}, ["rowLine"]))
                                
                                if (filtered.length-1 == i){
                                    reportDatasecond.push(Object.assign({}, ["rowLine"]))
                                    var SiteTotal = [
                                        {content:"",colSpan:3,styles:{halign:"left"}},
                                        {},
                                        {},
                                        {content: "Site Total:",styles:{fontStyle:"bold",halign:"center"}},
                                        {content: Number(ordered_per_piece_total),styles:{fontStyle:"bold"}},
                                        {content: Number(ordered_per_case_total),styles:{fontStyle:"bold"}},
                                        {content: Number(served_per_piece_total),styles:{fontStyle:"bold"}},
                                        {content: Number(served_per_case_total),styles:{fontStyle:"bold"}},
                                        {content: Number(balance_per_piece_total),styles:{fontStyle:"bold"}},
                                        {content: Number(balance_per_case_total),styles:{fontStyle:"bold"}},
                                        {content: this.convertToCurrency(Number(amount_balance_total)),styles:{fontStyle:"bold"}},
                                    ]
                                    reportDatasecond.push(Object.assign({}, SiteTotal))
                                    if (siteSpecific.length-1 == x){
                                        var GrandTotal = [
                                            {content:"",colSpan:3,styles:{halign:"left"}},
                                            {},
                                            {},
                                            {content: "Grand Total:",styles:{fontStyle:"bold",halign:"center"}},
                                            {content: Number(ordered_per_piece_gtotal),styles:{fontStyle:"bold"}},
                                            {content: Number(ordered_per_case_gtotal),styles:{fontStyle:"bold"}},
                                            {content: Number(served_per_piece_gtotal),styles:{fontStyle:"bold"}},
                                            {content: Number(served_per_case_gtotal),styles:{fontStyle:"bold"}},
                                            {content: Number(balance_per_piece_gtotal),styles:{fontStyle:"bold"}},
                                            {content: Number(balance_per_case_gtotal),styles:{fontStyle:"bold"}},
                                            {content: this.convertToCurrency(Number(amount_balance_gtotal)),styles:{fontStyle:"bold"}},
                                        ]
                                        reportDatasecond.push(Object.assign({}, GrandTotal))
                                    }
                                }
                                doc.autoTable({
                                    head: TOP_HEADER,
                                    body: reportDatasecond,
                                    theme: 'plain',
                                    tableWidth: 'auto',
                                    headStyles: {
                                        lineWidth: 0.15,
                                        cellPadding: 2
                                    },
                                    styles: {
                                        cellPadding: 1.0, fontSize: 9,
                                        halign: 'right'
                                    },
                                    margin: { top: 40 },
                                    didParseCell: function(data) {
                                        if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                            data.cell.styles.fillColor = [0, 0, 0]
                                            data.cell.styles.fontSize = 1
                                            data.cell.styles.cellPadding = 0
                                        } else if (data.row.section == 'body' && data.row.raw[0] == 'Grand Total :'){
                                            data.cell.styles.fontStyle = 'bold'
                                        }
                                    }
                                })
                            }
                            
                            
                        }
                    }

                    let pageCount = doc.internal.getNumberOfPages();
                    for(let i = 0; i < pageCount; i++) { 
                        doc.setPage(i);
                        doc.text(340,210,"Page " + doc.internal.getCurrentPageInfo().pageNumber  + " of " + pageCount, "right")
                    }

                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateReportBg: async function () {
                this.spinning = true;

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    this.spinning = false;
                    return
                }

                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                let parameters = {
                    site_id: this.inputSite.toString(),
                    date_from: from_date,
                    date_to: to_date,
                    status: this.inputStatus
                }

                var get_request = await HTTPRequest.getRequestReport(this.endPoint + 'sto_discrepancy_background?', parameters);

                if(get_request.error) {
                    this.openNotificationWithIcon('error', get_request.error);
                    this.spinning = false;
                    return
                }

                this.$notification['success']({
                    message: 'Report Generating',
                    description: 'Report running in background. Check jobs page to monitor report generation.',
                    style:{
                        color: 'rgba(0, 0, 0, 0.65)',
                        border: '1px solid #b7eb8f',
                        backgroundColor: '#f6ffed'
                    }
                });

                this.spinning = false;
            },
            generateFile: async function() {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'sto_discrepancy_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&status=' + this.inputStatus, null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                let siteSpecific = get_request;
                if(get_request.length > 0){
                    let site_specific = [];
                    let headers = [];
                    let first_header = [];
                    let second_header = [];
                    headers.push(' ','STO#','  ','To Site','   ','Date','Cancel Date','Status','STO Amount','STI#','    ')
                    first_header.push('PCode','Barcode','Description',' ','Out',' ','In',' ','Balance',' ','Balance Amount')
                    second_header.push(' ',' ',' ','Content/Case','Piece','Case','Piece','Case','Piece','Case',' ')
                    var ordered_per_piece_gtotal = 0,ordered_per_case_gtotal = 0,served_per_piece_gtotal = 0,served_per_case_gtotal = 0,balance_per_piece_gtotal = 0,balance_per_case_gtotal = 0,amount_balance_gtotal = 0;
                    for(let x=0; x < siteSpecific.length; x++){
                        this.reportDetails = siteSpecific[x].report_details
                        let reportData = [];
                        if (this.reportDetails.length > 0){
                            const ids = this.reportDetails.map(o => o.id)
                            let reportLine = this.reportDetails.filter(({id}, index) => !ids.includes(id, index + 1))
                            var ordered_per_piece_total = 0,ordered_per_case_total = 0,served_per_piece_total = 0,served_per_case_total = 0,balance_per_piece_total = 0,balance_per_case_total = 0,amount_balance_total = 0;
                            for(let i=0; i < reportLine.length; i++){
                                let reportdocumentDetails = reportLine[i]
                                let obj = this.reportDetails.filter(o => o.id == reportdocumentDetails.id);
                                let detail = [' ',reportdocumentDetails.document_no,' ',
                                    reportdocumentDetails.to_site,' ',
                                    moment(reportdocumentDetails.document_date).format("L"),
                                    moment(reportdocumentDetails.cancellation_date).format("L"),
                                    reportdocumentDetails.doc_status,
                                    this.convertToCurrency(Number(reportdocumentDetails.amount_net)),
                                    reportdocumentDetails.sti_doc_no,' '
                                ];
                                
                                (i!=0) ? reportData.push(Object.assign({}, headers)) : ''
                                reportData.push(Object.assign({}, detail))
                                reportData.push(Object.assign({}, [' ',' ']))
                                reportData.push(Object.assign({}, first_header))
                                reportData.push(Object.assign({}, second_header))
                                var ordered_per_piece_subtotal = 0, ordered_per_case_subtotal = 0, served_per_piece_subtotal = 0, served_per_case_subtotal = 0, balance_per_piece_subtotal = 0, balance_per_case_subtotal = 0, amount_balance_subtotal = 0;
                                for(var o= 0; o < obj.length; o++){
                                    var reportdocumentLineDetails = obj[o];
                                    ordered_per_piece_subtotal += Number(reportdocumentLineDetails.ordered_per_piece)
                                    ordered_per_case_subtotal += Number(reportdocumentLineDetails.ordered_per_case)
                                    served_per_piece_subtotal += Number(reportdocumentLineDetails.served_per_piece)
                                    served_per_case_subtotal += Number(reportdocumentLineDetails.served_per_case)
                                    balance_per_piece_subtotal += Number(reportdocumentLineDetails.balance_per_piece)
                                    balance_per_case_subtotal += Number(reportdocumentLineDetails.balance_per_case)
                                    amount_balance_subtotal += Number(reportdocumentLineDetails.amount_balance)
                                    var lineDetails = [reportdocumentLineDetails.product_id,
                                            reportdocumentLineDetails.barcode,
                                            reportdocumentLineDetails.description,
                                            Number(reportdocumentLineDetails.content),
                                            Number(reportdocumentLineDetails.ordered_per_piece),
                                            Number(reportdocumentLineDetails.ordered_per_case),
                                            Number(reportdocumentLineDetails.served_per_piece),
                                            Number(reportdocumentLineDetails.served_per_case),
                                            Number(reportdocumentLineDetails.balance_per_piece),
                                            Number(reportdocumentLineDetails.balance_per_case),
                                            this.convertToCurrency(Number(reportdocumentLineDetails.amount_balance))
                                    ]
                                    reportData.push(Object.assign({}, lineDetails))
                                }
                                var remarksAndSubtotal = ["Remarks: ",
                                    reportdocumentDetails.remark," ",
                                    "Subtotal:",
                                    Number(ordered_per_piece_subtotal),
                                    Number(ordered_per_case_subtotal),
                                    Number(served_per_piece_subtotal),
                                    Number(served_per_case_subtotal),
                                    Number(balance_per_piece_subtotal),
                                    Number(balance_per_case_subtotal),
                                    this.convertToCurrency(Number(amount_balance_subtotal)),
                                ]
                                reportData.push(Object.assign({}, remarksAndSubtotal))
                                reportData.push(Object.assign({}, [' ',' ']))
                                ordered_per_piece_total += ordered_per_piece_subtotal
                                ordered_per_case_total += ordered_per_case_subtotal
                                served_per_piece_total += served_per_piece_subtotal
                                served_per_case_total += served_per_case_subtotal
                                balance_per_piece_total += balance_per_piece_subtotal
                                balance_per_case_total += balance_per_case_subtotal
                                amount_balance_total += amount_balance_subtotal
                                ordered_per_piece_gtotal += ordered_per_piece_subtotal
                                ordered_per_case_gtotal += ordered_per_case_subtotal
                                served_per_piece_gtotal += served_per_piece_subtotal
                                served_per_case_gtotal += served_per_case_subtotal
                                balance_per_piece_gtotal += balance_per_piece_subtotal
                                balance_per_case_gtotal += balance_per_case_subtotal
                                amount_balance_gtotal += amount_balance_subtotal
                                
                                if (reportLine.length-1 == i){
                                    reportData.push(Object.assign({}, [' ',' ']))
                                    var SiteTotal = [" "," "," ",
                                        "Site Total:",Number(ordered_per_piece_total),
                                        Number(ordered_per_case_total),
                                        Number(served_per_piece_total),
                                        Number(served_per_case_total),
                                        Number(balance_per_piece_total),
                                        Number(balance_per_case_total),
                                        this.convertToCurrency(Number(amount_balance_total)),
                                    ]
                                    reportData.push(Object.assign({}, SiteTotal))
                                    if (siteSpecific.length-1 == x){
                                        var GrandTotal = [" "," "," ",
                                            "Grand Total:",
                                            Number(ordered_per_piece_gtotal),
                                            Number(ordered_per_case_gtotal),
                                            Number(served_per_piece_gtotal),
                                            Number(served_per_case_gtotal),
                                            Number(balance_per_piece_gtotal),
                                            Number(balance_per_case_gtotal),
                                            this.convertToCurrency(Number(amount_balance_gtotal)),
                                        ]
                                        reportData.push(Object.assign({}, GrandTotal))
                                    }
                                }
                            }
                        }


                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push(["Stock Transfer Out Discrepancy Report", "Generate By: " + printed_by])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply([], keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );

                                  console.log(result)
                                  newJsonData.push(result)
                        }
                        console.log(newJsonData)
                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                        // this.JsonData = site_specific;
                    }
                        // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('error', 'No Data.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
        }
    };
</script>

<style></style>
